import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives/object-id-schema';
import { AggregationMethodSchema } from '../meter/aggregation-method/aggregation-method-schema';
import { FilterSchema } from '../meter/filter-schema';

export const NewLineItemProductVariantMeterSchema = oz.object({
  meterId: ObjectIdSchema,
  name: oz.string(),
  eventName: oz.string(),
  filter: FilterSchema.optional(),
  aggregationMethod: AggregationMethodSchema,
}).openapi('NewLineItemProductVariantMeter');

export type NewLineItemProductVariantMeter = oz.infer<typeof NewLineItemProductVariantMeterSchema>;